// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Assets/newsletter_finger_top.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Assets/name.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Assets/email.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./Assets/password.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Assets/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./Assets/greensign.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./Assets/wrongi.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./Assets/downarrows.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./Assets/left-arrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Manrope", sans-serif !important;
}

h5 {
  font-weight: 700;
}

h2 {
  font-size: 48px;
  line-height: 56px;
  font-weight: 700;
}
.gtranslate_wrapper{
  /* position: fixed;
  z-index: 999;
  right: 9%;
  top: 20px; */
  position: fixed;
  z-index: 999;
  left: 16%;
  top: 15px;
  display: flex;
}
a.glink img{
  height: 24px !important;
  width: 24px !important;
}
a.gt_switcher-popup.glink, .gt_switcher-popup span{
  color: #fff !important;
  display: flex;
  align-items: center;
  /* gap: 4px; */
  padding-left: 5px;
}
.labelname{
  font-weight: 600;
}
.color-grey-500 {
  color: #3d565f;
}
.hset{
  height: 460px;
    overflow-y: auto;
}
.alllogin input {
  width: 2.4em !important;
  height: 2.4em;
}

.alllogin span {
  margin: 0px 8px !important;
}

.error-msg {
  margin-top: 8px;
  margin-left: 5px;
  font-size: 15px;
  color: red;
  text-align: start !important;
}

/* header css */
.burger-icon {
  cursor: pointer;
  /* position: absolute;
  height: 20px;
  right: 0;
  top: 10px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 24px;
  z-index: 1004; */
  font-size: 30px;
  margin-top: -5px;
}
.profile_dropdowns{
  right: 0;
}

.header .burger-icon {
  display: none;
}

.burger-icon {
  top: 22px;
}

.burger-icon.burger-close {
  width: 15px;
}

.burger-icon>span {
  display: block;
  height: 2px;
  left: 0;
  position: absolute;
  width: 100%;
}

.burger-icon>span.burger-icon-top {
  top: 2px;
}

.burger-icon>span.burger-icon-bottom {
  bottom: 2px;
}

.burger-icon>span.burger-icon-mid {
  top: 9px;
}

.burger-icon.burger-close {
  position: fixed;
  right: 30px;
  top: 16px;
}

.burger-icon.burger-close>span.burger-icon-top {
  display: none;
  opacity: 0;
}

.burger-icon.burger-close>span.burger-icon-mid {
  top: 8px;
  transform: rotate(45deg);
}

.burger-icon.burger-close>span.burger-icon-bottom {
  bottom: 10px;
  transform: rotate(-45deg);
}

.burger-icon>span:after,
.burger-icon>span:before {
  background-color: #333;
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.burger-icon.burger-icon-white>span:after,
.burger-icon.burger-icon-white>span:before {
  background-color: #3d565f;
}

.burger-icon.burger-close.burger-icon-white>span:after,
.burger-icon.burger-close.burger-icon-white>span:before {
  background-color: var(--primary-color);
}

.btn.close {
  font-size: 22px;
  color: #2d699b;
}

.offcanvas-header {
  border-bottom: 1px solid #cde2e7;
}

.offcanvas-header .logos {
  max-width: 60%;
}

.fw-700 {
  font-weight: 700;
}

.offcanvas-body {
  /* display: flex;
  align-items: center;
  justify-content: center; */
}

.offcanvas-body h4 {
  color: #2d699b;
  text-align: center;
}

.header {
  border-bottom: 1px solid #b9cad0;
  background-color: #fff;
  float: left;
  padding: 0;
  /* position: relative; */
  width: 100%;
  position: fixed;
  z-index: 777;
  top: 0;
}

.kXOQrs {
  justify-content: start !important;
}
.hChFUv {
  justify-content: start !important;
}

.header .main-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.header .main-header .header-left {
  align-items: center;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.font-sm{
  font-size: 14px;
  line-height: 18px;
}
.color-grey-400{
  color: #4e6770 !important;
}
.header .main-header .header-left .header-logo {
  max-width: 150px;
  width: 100%;
}

.header .main-header .header-left .header-logo a {
  display: block;
}

.header .main-header .header-left .header-logo a img {
  min-height: 37px;
  max-width: 100%;
}

.header .main-header .header-left .header-nav {
  display: inline-block;
  text-align: left;
  /* width: 75%;
  margin-left: 25px; */
}

.header .nav-main-menu {
  float: none;
  padding: 0;
  width: auto;
}

div.ruby-menu-demo-header {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: auto;
  padding: 0;
  margin: 0;
  z-index: 9999;
}

div.ruby-wrapper {
  position: relative;
  /* width: 780px; */
  height: 50px;
  margin: 0 auto;
  background: #fff;
}

div.ruby-wrapper,
div.ruby-wrapper.ruby-vertical {
  /* background: #f9f9f9; */
  color: #222;
}

div.ruby-wrapper ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

div.ruby-wrapper>ul {
  position: relative;
}

ul.ruby-menu>li {
  float: left;
  font-size: 14px;
}

ul.ruby-menu>li>a {
  display: block;
  line-height: 50px;
  padding: 0 15px 0 15px;
  color: #071920;
  text-decoration: none;
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  position: relative;
}

ul.ruby-menu>li>a:hover,
ul.ruby-menu>li:hover>a,
ul.ruby-menu>li.ruby-active-menu-item>a:hover,
ul.ruby-menu>li.ruby-active-menu-item:hover>a {
  background: #2d699b;
}

ul.ruby-menu>li>a:hover,
ul.ruby-menu>li:hover>a,
ul.ruby-menu>li.ruby-active-menu-item>a:hover,
ul.ruby-menu>li.ruby-active-menu-item:hover>a {
  /* background: #222; */
  color: #fff;
}

ul.ruby-menu>li>ul,
ul.ruby-menu>li>ul>li>ul,
ul.ruby-menu>li>ul>li>ul>li>ul {
  position: absolute;
  box-shadow: 0 8px 24px -5px #ccc;
  border-top: 4px solid #2d699b;
}

ul.ruby-menu>li>ul>li,
ul.ruby-menu>li>ul>li>ul>li {
  position: relative;
}

ul.ruby-menu>li>ul>li>a,
ul.ruby-menu>li>ul>li>ul>li>a,
ul.ruby-menu>li>ul>li>ul>li>ul>li>a {
  display: block;
  width: 250px;
  line-height: 40px;
  padding: 0 35px 0 25px;
  background: #fff;
  color: #666;
  text-decoration: none;
  font-size: 14px;
}
.FooterHeadquater{
  color: black;
  transition: all .3s ease 0s;
}
.FooterHeadquater:hover {
  color: #f15f34;
}

ul.ruby-menu>li>ul>li>a,
ul.ruby-menu>li>ul>li>ul>li>a,
ul.ruby-menu>li>ul>li>ul>li>ul>li>a {
  background: #fff;
  color: #666;
  font-weight: 600;
}

ul.ruby-menu>li>ul>li>a:only-child:after,
ul.ruby-menu>li>ul>li>ul>li>a:only-child:after,
ul.ruby-menu>li>ul>li>ul>li>ul>li>a:only-child:after {
  content: "";
}

span.ruby-dropdown-toggle {
  transition: transform 0.3s ease;
}

ul.ruby-menu>li>ul>li:hover>a,
ul.ruby-menu>li>ul>li>a:hover,
ul.ruby-menu>li>ul>li>ul>li:hover>a,
ul.ruby-menu>li>ul>li>ul>li>a:hover,
ul.ruby-menu>li>ul>li>ul>li>ul>li:hover>a,
ul.ruby-menu>li>ul>li>ul>li>ul>li>a:hover {
  background: #efefef;
}

ul.ruby-menu>li>ul>li>ul,
ul.ruby-menu>li>ul>li>ul>li>ul {
  left: 250px;
  top: -4px;
  z-index: 100;
}

ul.ruby-menu>li>ul>li.ruby-open-to-left>ul,
ul.ruby-menu>li>ul>li>ul>li.ruby-open-to-left>ul {
  left: auto;
  right: 250px;
}

.header .main-header .header-left .header-right {
  padding: 15px 0 15px 15px;
  text-align: right;
  /* width: 40%; */
}

.btn.btn-brand-1 {
  background: #2d699b;
  border-radius: 4px;
  color: #ffe7bb;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  padding: 15px 24px;
  width: 100%;
  max-width: 140px;
}
@media (min-width:1200px) and (max-width:1399px) {
  .header-right .get_start_button .btn.btn-brand-1 {
    padding: 15px 24px !important; 
}
}
.btn.btn-brand-1:hover {
  background-color: #d83d10;
  color: #ffe7bb;
}

/* header css end */

/* footer */
img {
  max-width: 100%;
  transition: all 0.3s ease 0s;
}

h6 {
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
}

.mb-10 {
  margin-bottom: 10px !important;
}

.mt-15 {
  margin-top: 15px !important;
}

a:hover {
  color: #f05a2d;
}

.icon-socials {
  background-size: contain !important;
  display: inline-block;
  height: 21px;
  margin-right: 8px;
  transition-duration: 0.2s;
  vertical-align: middle;
  width: 21px;
}

.icon-socials:hover {
  transform: translateY(-3px);
  transition-duration: 0.2s;
}

footer {
  display: block;
}

.footer-1 {
  background-color: #fff;
  margin: 0;
  padding: 90px 0 25px;
}

footer a {
  text-decoration: none;
}

.color-brand-1 {
  color: #2d699b !important;
}

.footer .width-20 {
  width: 20%;
}

.footer .width-25 {
  width: 25%;
}

.footer .width-22 {
  width: 22%;
}

.footer .width-23 {
  width: 23%;
}

.footer .width-16 {
  width: 19%;
}

.footer .menu-footer {
  display: inline-block;
}

.footer .menu-footer li {
  list-style: none;
  margin-bottom: 8px;
}

.footer .menu-footer li a {
  color: #4e6770;
  display: block;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  padding: 0;
  text-decoration: none;
  transition-duration: 0.2s;
}

.footer .menu-footer li a:hover {
  color: var(--primary-color);
  padding-left: 2px;
  transition-duration: 0.2s;
}

.footer .footer-bottom {
  border-top: 1px solid #6a838c;
  color: #3d565f;
  font-size: 14px;
  padding: 30px 0;
}

.footer .menu-footer {
  display: inline-block;
  padding: 0;
}

.footer .menu-footer li {
  list-style: none;
  margin-bottom: 8px;
}

.footer .menu-footer li a {
  color: #4e6770;
  display: block;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  padding: 0;
  text-decoration: none;
  transition-duration: 0.2s;
}

.footer .menu-footer li a:hover {
  color: #2d699b;
  padding-left: 2px;
  transition-duration: 0.2s;
}

.footer-custom {
  background-color: #0e2130;
  display: inline-block;
  padding: 0;
  position: relative;
  width: 100%;
}

.footer .footer-bottom {
  border-top: 1px solid #ecf1f2;
  color: #3d565f;
  font-size: 14px;
  padding: 30px 0;
}

.font-md {
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
}

.color-grey-300 {
  color: #6a838c;
}

#scrollUp,
.footer .footer-bottom a {
  text-decoration: none;
}

#scrollUp {
  position: fixed;
  background-color: #fff;
  background-color: #2d699b;
  border: 0;
  border-radius: 8px;
  bottom: 20px;
  color: #fff;
  height: 56px;
  overflow: hidden;
  right: 20px;
  text-align: center;
  transition-duration: 0.2s;
  width: 56px;
  z-index: 999 !important;
  display: flex;
  justify-content: center;
  align-items: center;
}



/* chart start */
.chatbox {
  position: fixed;
  bottom: 5%;
  right: 20px;
  background-color: #2d699b;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  z-index: 999 !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chatbox svg {
  fill: #fff;
}

.chatlist {
  position: fixed;
  right: 80px;
  bottom: 12%;
  height: 550px;
  width: 400px;
  overflow: hidden;
  border: 1px solid #fff;
  background-color: #fff;
  z-index: 1050;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
}

.pos {
  position: relative;
  z-index: 3;
}

.wrapss {
  display: flex;
  /* flex-wrap: wrap; */
  overflow: auto;
  gap: 4px;
  background-color: #fff;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  /* margin: 0px 8px 6px 8px; */
  padding: 4px 4px;
  position: absolute;
  width: 96%;
  left: 0;
  z-index: 5;
  bottom: 12%;
}

.textbreak {
  word-wrap: break-word;
}

.widthset {
  width: 90px;
  min-width: 90px;
  background: #00000017;
  /* margin: auto; */
  text-align: center;
  border-radius: 4px;
  word-wrap: break-word;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #98bfded6;
}

.closeicon {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 1px;
  right: 1px;
  color: #000;
  cursor: pointer;
}

.chatimage {
  width: 100px;
  height: 100px;
  object-fit: contain;
}

.uploadlogos {
  width: 70px;
  height: 70px;
  object-fit: contain;
}

.chat_head {
  background-color: #2d699b;
  color: #fff;
  padding: 10px 20px;
  text-align: center;
}

.chattext_box {
  padding: 14px 8px;
  height: 440px;
  min-height: 440px;
  overflow-y: auto;
}

.box_left {
  width: 300px;
  min-width: 300px;
  background-color: #ffe7bb;
  padding: 10px;
  border-radius: 4px;
  color: #000;
  position: relative;
  z-index: 2;
}

.box_right {
  width: 300px;
  min-width: 300px;
  background-color: #2d699b;
  padding: 10px;
  border-radius: 4px;
  color: #fff;
  margin-left: auto;
  position: relative;
  z-index: 2;
}

.btn.btn-brand-1.sendbtn {
  padding: 8px 10px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn.btn-brand-1.sendbtn svg {
  font-size: 25px;
}

.chatlist input {
  color: #000 !important;
  font-weight: 500 !important;
}

.chattext_box::-webkit-scrollbar-track,
.wrapss::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}

.chattext_box::-webkit-scrollbar,
.wrapss::-webkit-scrollbar {
  width: 9px;
  height: 5px;
  background-color: #F5F5F5;
}

.chattext_box::-webkit-scrollbar-thumb,
.wrapss::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #2d699b;
}

.cursor {
  cursor: pointer;
}

.full_list {
  padding-top: 20%;
  text-align: center;
}

.full_list .btn {
  width: 250px;
  min-width: 250px;
  margin: auto;
}

.otplist div {
  justify-content: center;
  gap: 6px;
  margin-bottom: 10px;
}

.otplist input {
  width: 2.5em !important;
  height: 2.5em !important;
}

.img_head {
  width: 120px;
}

.fw-600 {
  font-weight: 600;
}

.timepos {
  position: absolute;
  bottom: 2px;
  right: 7px;
  font-size: 10px;
  font-weight: 600;
}

.playpos {
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 28px;
  transform: translate(-50%, -50%);
}

/* chat end */



#scrollUp i {
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 56px !important;
}

#scrollUp:hover {
  background-color: #d83d10;
  transform: translateY(-3px);
  transition-duration: 0.2s;
}

.footer .width-16,
.footer .width-20 {
  margin-bottom: 20px;
}

/* footer css end */

/* inner page */
.box-newsletter {
  border-radius: 0;
  background-color: #96bfe0;
  border-radius: 8px;
  display: inline-block;
  padding: 40px;
  position: relative;
  width: 100%;
}

.box-newsletter:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 100% 0;
  background-size: cover;
  content: "";
  height: 100px;
  position: absolute;
  right: 0;
  top: 0;
  width: 111px;
}

.box-newsletter .box-image-newsletter {
  position: relative;
}

.box-newsletter .image-1 {
  bottom: -45px;
  left: 0;
  position: absolute;
}

.shape-2 {
  animation: hero-thumb-sm-animation 4s linear infinite alternate;
}

@keyframes hero-thumb-sm-animation {
  0% {
    transform: translateY(-20px) translateX(50px);
  }

  100% {
    transform: translateY(-20px) translateX(0);
  }
}

.font-lg {
  font-size: 18px;
  line-height: 23px;
  font-weight: 500;
}

.box-newsletter .form-newsletter {
  background: #fff;
  border-radius: 8px;
  padding: 10px;
}

.box-newsletter .form-newsletter form {
  display: flex;
}

.box-newsletter .form-newsletter form input {
  border: 0;
  box-shadow: none;
  color: #071920;
  outline: 0;
  padding: 10px;
  width: 100%;
  transition: all 0.3s ease 0s !important;
  font-size: 14px;
}

.btn.btn-submit-newsletter {
  background-color: #2d699b;
  border-radius: 8px;
  padding: 15px 16px 16px;
}

.box-newsletter .img-main {
  border-radius: 565px;
  max-width: 100%;
  width: 100%;
}

.btn.btn-submit-newsletter:hover {
  background-color: #d83d10;
}

.btn.btn-submit-newsletter svg {
  color: #fff;
}

.section {
  display: inline-block;
  width: 100%;
  padding-top: 50px;
}

.font-md {
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
}

.box-page-register {
  border-bottom: 1px solid #cde2e7;
  padding-bottom: 110px;
  position: relative;
}

.box-page-register:before {
  background-color: #e0f1f4;
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 33%;
  z-index: 1;
}

.box-page-register .container {
  position: relative;
  z-index: 2;
}

.box-steps-small {
  padding-left: 90px;
  padding-right: 150px;
  padding-top: 200px;
}

.box-steps-small .item-number {
  cursor: pointer;
  margin-bottom: 30px;
}

.item-number {
  display: flex;
  /* margin-bottom: 40px; */
  position: relative;
}

.hover-up,
.hover-up:hover {
  transition: all 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
}

.hover-up:hover {
  transform: translateY(-2px);
}

.box-steps-small .item-number.active .num-ele,
.box-steps-small .item-number:hover .num-ele {
  background-color: #06d6a0;
}

.item-number .num-ele {
  background-color: #2d699b;
  border-radius: 50%;
  color: #ffe7bb;
  font-size: 48px;
  font-weight: 700;
  height: 83px;
  line-height: 83px;
  margin-right: 20px;
  max-width: 83px;
  min-width: 83px;
  text-align: center;
  width: 83px;
}

.box-steps-small .item-number .num-ele {
  font-size: 26px;
  height: 48px;
  line-height: 48px;
  max-width: 48px;
  min-width: 48px;
  width: 48px;
}

.item-number .info-num {
  width: 100%;
}

.box-steps-small .item-number .info-num h5 {
  margin-bottom: 8px !important;
}

.box-register {
  padding: 100px 130px 0 0;
}

.form-control,
.form-control__input-container,
.form-control__control {
  border: 1px solid #cde2e7 !important;
  border-radius: 8px !important;
  color: #3d565f !important;
  height: 54px !important;
  padding: 18px 20px !important;
}
.gt_container-unisv1 a.glink span{
  margin-right: 7px !important;
  font-size: 15px !important;
  vertical-align: middle;
}
.icon-name {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
/* .date_class.icon-name {
  background-image: unset !important;
} */
input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
}
.icon-email {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.icon-password {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.icon-gender {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.form-control.icon-password {
  background-image: unset;
}

.eyepassword {
  position: absolute;
  top: 25%;
  font-size: 20px;
  right: 3%;
  color: #757d85;
  cursor: pointer;
}

.icon-name,
.icon-password {
  background-position: right 15px center;
  background-repeat: no-repeat;
  padding-right: 40px !important;
}

.icon-email,
.icon-user {
  background-position: right 15px center;
  background-repeat: no-repeat;
  padding-right: 40px;
}

.icon-gender {
  background-position: right 15px center;
  background-repeat: no-repeat;
  padding-right: 40px;
}

.is-valid~.valid-feedback,
.is-valid~.valid-tooltip,
.was-validated :valid~.valid-feedback,
.was-validated :valid~.valid-tooltip {
  display: block !important;
}
.dwfkuc {
    border-bottom: 1px solid rgba(0, 0, 0, .12) !important;
    border-top: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
    font-weight: 700;
}
.ehdHJD{
  justify-content: flex-start !important;
}
.form-control.is-valid,
.was-validated .form-control:valid {
  border-color: #198754 !important;
  padding-right: calc(1.6em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) !important;
  background-repeat: no-repeat !important;
  /* background-position: right calc(0.375em + 0.1875rem) center !important; */
  background-position: 97% 20px !important;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;
}

.form-control.icon-password.is-valid,
.was-validated .form-control.icon-password:valid {
  background-image: unset !important;
}

.form-control.is-valid:focus,
.was-validated .form-control:valid:focus {
  border-color: #198754 !important;
  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25) !important;
}

.form-control.is-invalid,
.was-validated .form-control:invalid {
  border-color: #dc3545 !important;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) !important;
  background-repeat: no-repeat !important;
  background-position: right calc(0.375em + 0.1875rem) center !important;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;
}

.form-control.icon-password.is-invalid,
.was-validated .form-control.icon-password:invalid {
  background-image: unset !important;
}

.form-control.is-invalid:focus,
.was-validated .form-control:invalid:focus {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25) !important;
}

.form-control:focus {
  border-color: #06d6a0 !important;
}

[type="text"].form-control:focus,
input.form-control:focus,
input[type="text"]:focus {
  box-shadow: unset !important;
}

.cb-container {
  display: flex;
  align-items: center;
}

.cb-container input {
  width: 23px;
  height: 24px;
}

.cb-container .text-small {
  color: #3d565f;
  font-weight: 500;
}

.form-check-input:checked {
  background-color: #06d6a0 !important;
  border: 1px solid #06d6a0 !important;
}

.form-check-input:focus {
  box-shadow: unset !important;
}

.btn.btn-brand-lg {
  background: #2d699b;
  border-radius: 8px;
  color: #ffe7bb;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  /* padding: 20px 24px; */
  padding: 10px 24px;
}

.btn.btn-full {
  width: 100%;
}

.btn.btn-brand-lg:hover {
  background-color: #d83d10;
}

.color-success {
  color: #06d6a0;
  text-decoration: none;
  font-weight: 600;
}

.banner-login {
  height: 600px;
}

.box-banner-abs {
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}

.icon-user {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
/* background-position: 0 0 !important; */
}

.customer-reset-password {
  padding-top: 90px;
}
.MobileAccordionTitle:hover {
  color: #2adcae !important;
}

@media screen and (min-width:1400px) {
div.ruby-wrapper {
  /* width: 900px !important; */
}
ul.ruby-menu>li>a {
  padding: 0 22px 0 25px;
}
}

@media screen and (min-width:1400px) and (max-width:1799px) {
   .gtranslate_wrapper{
    left: 7%;
    top: 15px;
   }
}

@media (max-width: 1399.98px) {
  .box-steps-small {
    padding-left: 0;
    padding-right: 50px;
    padding-top: 180px;
  }

  .box-register {
    padding-right: 0;
  }

  .box-banner-login {
    margin: auto;
    max-width: 450px;
  }

  .box-banner-abs {
    left: auto;
    position: relative;
    top: auto;
    transform: none;
  }

  .banner-login .box-banner-abs {
    top: 40%;
    transform: translateY(-40%);
  }

  .banner-login .box-banner-abs {
    padding: 60px 0;
    top: auto;
    transform: none;
  }

  .box-steps-small .item-number{
    width: 80%;
  }
}

@media screen and (min-width:1200px) and (max-width:1399px) {
  .gtranslate_wrapper {
    left: 3%;
    top: 15px;
  }
 .header .container{
  max-width: 98%;
 }
 .gset{
  width: max-content;
 }
}

@media (max-width: 1199.98px) {
  .header .burger-icon {
    display: block;
  }

  .header .main-header .header-left .header-right {
    padding-right: 40px;
    text-align: right;
    /* width: 100%; */
  }

  .header .header-right .btn.btn-brand-1 {
    padding: 8px 16px;
  }
}

@media screen and (min-width: 1140px) {
  .customer-reset-password {
    width: 50%;
  }
}

@media screen and (min-width:992px) and (max-width:1199px) {
  .gtranslate_wrapper {
    left: 3%;
    top: 15px;
  }
}


@media screen and (max-width: 991.98px) {

  .footer .width-16,
  .footer .width-20 {
    margin-bottom: 20px;
  }
  .footer .width-23 {
    width: 100%;
    margin-top: 10px;
  }

  .footer .width-16,
  .footer .width-20 {
    width: 50%;
  }

  .box-newsletter .box-image-newsletter {
    margin-bottom: 40px;
  }

  .box-register,
  .box-steps-small {
    padding-top: 50px;
  }

  .box-page-register:before {
    width: 100%;
  }

  h2 {
    font-size: 36px;
    line-height: 46px;
  }

  .box-steps-small .item-number{
    width: 100%;
  }
}

@media screen and (min-width:768px) and (max-width:991px) {
  .gtranslate_wrapper {
    left: 5%;
    top: 15px;
  }
}
@media screen and (min-width: 768px) {
  ul.ruby-menu>li>a:after {
    /* font-family: "FontAwesome";
    text-decoration: none;
    content: '\\f107'; */
    content: "";
    position: absolute;
    margin-left: 0px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat;
    width: 20px;
    height: 20px;
    top: 15px;
    display: none;
  }

  ul.ruby-menu>li:hover>a:after {
    transform: rotate(-180deg);
    filter: invert(1);
  }

  ul.ruby-menu>li>ul,
  ul.ruby-menu>li>ul>li>ul,
  ul.ruby-menu>li>ul>li>ul>li>ul {
    visibility: hidden;
    opacity: 0;
  }

  ul.ruby-menu>li>ul>li>a:after,
  ul.ruby-menu>li>ul>li>ul>li>a:after,
  ul.ruby-menu>li>ul>li>ul>li>ul>li>a:after {
    font-family: "FontAwesome";
    text-decoration: none;
    font-size: 16px;
    padding: 0;
    content: "\\f105";
    position: absolute;
    right: 15px;
    display: none;
  }

  ul.ruby-menu>li:hover>ul,
  ul.ruby-menu>li>ul>li:hover>ul,
  ul.ruby-menu>li>ul>li>ul>li:hover>ul {
    visibility: visible;
    opacity: 1;
  }

  ul.ruby-menu>li>ul>li.ruby-open-to-left>a:after,
  ul.ruby-menu>li>ul>li>ul>li.ruby-open-to-left>a:after,
  ul.ruby-menu>li>ul>li>ul>li>ul>li.ruby-open-to-left>a:after {
    /* content: '\\f104';
  right: auto;
  left: 10px; */
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat;
    width: 12px;
    height: 12px;
    left: 5px;
    top: 14px;
    display: none;

  }

  ul.ruby-menu>li>ul>li.ruby-open-to-left:hover>a:after,
  ul.ruby-menu>li>ul>li>ul>li.ruby-open-to-left:hover>a:after,
  ul.ruby-menu>li>ul>li>ul>li>ul>li.ruby-open-to-left:hover>a:after {
    transform: rotate(-180deg);
  }
}

@media screen and (min-width: 767px) {
  ul.ruby-menu>li>a:after {
    transition: all 0.3s ease;
  }

  ul.ruby-menu>li>ul,
  ul.ruby-menu>li>div {
    transform: translateY(25px);
    transition: all 0.3s ease;
  }

  ul.ruby-menu>li>ul>li>a:after,
  ul.ruby-menu>li>ul>li>ul>li>a:after,
  ul.ruby-menu>li>ul>li>ul>li>ul>li>a:after {
    transition: all 0.3s ease;
  }

  ul.ruby-menu>li:hover>ul,
  ul.ruby-menu>li:hover>div {
    transform: translateY(0);
  }

  ul.ruby-menu>li>ul>li.ruby-open-to-left:hover>ul,
  ul.ruby-menu>li>ul>li>ul>li.ruby-open-to-left:hover>ul,
  ul.ruby-menu>li>ul>li>ul>li>ul>li.ruby-open-to-left:hover>ul {
    transform: translateX(0);
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .btn.btn-brand-1 {
    padding: 15px 24px;
  }
  .gtranslate_wrapper {
    left: 5%;
    top: 15px;
  }
  .header .container{
    max-width: 96%;
   }
   
   /* .gset{
    width: max-content;
   } */
}
.profile_dropdowns{
  background: #fff;
}
@media screen and (max-width: 767px) {
  h2 {
    font-size: 30px;
    line-height: 40px;
  }
  ul.ruby-menu>li>ul.profile_dropdowns {
    visibility: hidden;
    opacity: 0;
}
  ul.ruby-menu>li:hover>ul.profile_dropdowns {
    visibility: visible;
    opacity: 1;
}
}

@media (max-width: 575.98px) {
  .mobfont{
    font-size: 16px;
  }
  .header .main-header .header-left .header-logo a img {
    max-width: 110px;
}
  .gset{
    width: max-content;
   }
  .gt_white_content .gt_languages{
    flex-flow: column;
  }
  .gt_white_content{
    margin: unset !important;
    transform: translate(-50%,-50%) !important;
    width: 320px !important;
  }
  .box-newsletter .image-1 img {
    width: 75px;
  }
  .gt_container-unisv1 a.glink span {
    font-size: 17px;
}
a.glink img{
  width: 28px;
  height: 28px;
}
.gtranslate_wrapper {
  left: 3%;
  top: 15px;
}
.header-right .get_start_button .btn.btn-brand-1{
  display: none;
}
}

@media (max-width: 499.98px) {

  .footer .width-16,
  .footer .width-20,
  .footer .width-23 {
    width: 100%;
  }

  .box-newsletter .image-1 img {
    width: 55px;
  }

  h2 {
    font-size: 25px;
    line-height: 35px;
  }
  /* .gtranslate_wrapper {
    right: 20%;
  } */
  .burger-icon {
    top: 16px;
  }

  .box-newsletter {
    padding: 25px;
  }
}

/* 13-05-24 sakthi changes start */

.custom_uploadBtn input[type="file"] {
  max-width: 100%;
  padding: 5px;
  background: #fff;
  font-size: 14px;
  border: 1px solid #cde2e7 !important;
  border-radius: 8px !important;
  color: #3d565f !important;
}

.custom_uploadBtn input[type="file"]::file-selector-button {
  margin-right: 20px;
  border: none;
  background: #2d699b;
  padding: 7px 20px;
  border-radius: 8px;
  color: #ffe7bb;
  cursor: pointer;
  font-size: 12px;
}

.uploadLabel {
  color: #3d565f;
}

.upload_PreviewImg,
.custom_uploadBtn video {
  width: 180px;
  height: 180px;
}

.upload_PreviewImg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

@media (max-width:575px) {
  .upload_PreviewImg {
    width: 130px;
    height: 130px;
  }
}


/* start of hariharan css */

.custom_section {
  /* padding-top: 54px; */
  padding-top: 90px;
}

.profile_card {
  /* border: 1px solid var(--light_blue) !important; */
  /* border-radius: 10px; */
  /* padding: 30px; */
}

.profile_wrapper {
  min-width: 100px;
  width: 100px;
  max-width: 100px;
  min-height: 100px;
  height: 100px;
  max-height: 100px;
  border-radius: 50%;
  overflow: hidden;
  border: none;
  outline: none;
  padding: 0;
  cursor: pointer;
}

.profile_wrapper img {
  min-width: 100%;
  width: 100%;
  max-width: 100%;
  min-height: 100%;
  height: 100%;
  max-height: 100%;
  object-fit: cover;
}

/* start of toggle - 1 */

.custom_toggle .switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 22px;
}

.custom_toggle .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.custom_toggle .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  border: 1px solid var(--h_themeBlue);
  transition: 0.4s;
}

.custom_toggle .slider:before {
  position: absolute;
  content: "";
  top: 2px;
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background: var(--h_themeBlue);
  transition: 0.4s;
}

.custom_toggle input:checked+.slider {
  background: var(--h_themeBlue);
  /* border: 1px solid var(--primary-color); */
}

.custom_toggle input:focus+.slider {
  box-shadow: 0 0 1px var(--h_themeBlue);
}

.custom_toggle input:checked+.slider:before {
  transform: translateX(18px);
  background: var(--h_white);

}

/* Rounded sliders */
.custom_toggle .slider.round {
  border-radius: 34px;
}

.custom_toggle .slider.round:before {
  border-radius: 50%;
}

/* end of toggle -1 */

.profile_qr_wrapper {
  min-width: 200px;
  width: 200px;
  max-width: 200px;
  min-height: 200px;
  height: 200px;
  max-height: 200px;
  overflow: hidden;
}

.profile_qr_wrapper img {
  min-width: 100%;
  width: 100%;
  max-width: 100%;
  min-height: 100%;
  height: 100%;
  max-height: 100%;
  object-fit: contain;
}

.profile_label {
  font-size: 15px;
}

.proile_label_span {
  font-size: 13px;
  font-weight: 450;
  color: var(--h_darkGray);
}

.profile_desc {
  font-size: 15px;
  font-weight: 500;
}

.support_search_wrapper {
  padding: 8px;
  background: var(--h_lightGray);
  border-radius: 5px;
  max-width: 500px;
  height: 50px;
}

.support_search_wrapper input {
  border: none;
  outline: none;
  background: transparent;
  font-weight: 500;
  font-size: 15px;
}

.support_search_wrapper input::placeholder {
  opacity: 0.7;
}

.support_search_button {
  color: var(--h_white);
  background: var(--h_themeBlue);
  border: none;
  outline: none;
  padding: 5px 20px;
  border-radius: 5px;
  font-weight: 500;
}

.support_title {
  font-size: 17px;
}

.self_service_card_wrapper {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
}

.self_service_card {
  min-height: 150px;
  height: 150px;
  max-height: 150px;
  border-radius: 5px;
  padding: 20px;
  cursor: pointer;
  border: 1px solid var(--h_lightGray2);
}

.self_service_card img {
  width: 45px;
}

.container {
  /* max-width: 90%; */
}

.self_service_card p {
  font-weight: 450;
  color: var(--h_darkGray);
}

.self_service_card:hover {
  background: var(--h_lightGray2);
}

.faq_cms_section h5 {
  font-size: 18px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.faq_cms_section p {
  font-size: 15px;
  margin-top: 15px;
  margin-bottom: 15px;
  font-weight: 450;
  line-height: 2;
  color: var(--h_darkGray);
}


/* start of table - 1 */

/* start of table -3 */

.w_200 {
  min-width: 200px;
}

.w_150 {
  min-width: 150px;
}

.w_250 {
  min-width: 250px;
}

.w_150 {
  min-width: 150px;
}

.card_table {
  background: var(--grayClr1);
  padding: 15px;
  overflow: hidden;
}

.card_table .card_table_body {
  overflow: hidden;
}

.card_table .table-body.asrt-table-body {
  overflow: scroll;
  margin-top: 0px !important;
}

.card_table .table {
  background: transparent !important;
}

.card_table .table tr th {
  background: transparent !important;
  color: var(--blackWhite);
  border: none;
}

.card_table .table tr {
  border: none;
}

.card_table .table tr th {
  background: transparent !important;
  color: var(--h_themeBlue);
  border: none;
  border-bottom: 2px solid var(--h_themeBlue);
  padding-bottom: 20px !important;
  font-size: 15px;
}

.card_table .table.table-bordered tbody tr td {
  background: transparent;
  border: none;
  padding-top: 20px;
  padding-bottom: 20px;
  color: var(--h_black);
  font-size: 14px;
}

.card_table .row.table-foot.asrt-table-foot {
  margin: 30px 10px;
  /* border: 1px solid var(--green2); */
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 5px;
  background: transparent;
}

.card_table .row.table-foot.asrt-table-foot .col-md-6:first-child {
  align-items: center;
  display: flex;
  color: var(--h_black);
}

.card_table .row.table-foot.asrt-table-foot .pagination {
  border: none !important;
  /* background: var(--themeLinear); */
  width: fit-content;
  margin-left: auto;
  border-radius: 0.375rem;
}

.card_table .row.table-foot.asrt-table-foot .pagination .page-link {
  background: transparent;
  color: var(--h_black);
}

.card_table .row.table-foot.asrt-table-foot .pagination .page-link:hover {
  color: var(--h_themeBlue);
}

.card_table .row.table-foot.asrt-table-foot .pagination .page-link input {
  background: transparent;
  color: var(--h_black);
  box-shadow: none;
  outline: none;
}

.card_table .row.table-foot.asrt-table-foot .pagination .disabled.page-item .page-link {
  opacity: 0.7;
}

.card_table .table-striped>tbody>tr:nth-of-type(odd)>* {
  background: transparent !important;
}

.card_table .table-striped>tbody>tr:nth-of-type(odd)>* {
  --bs-table-bg-type: none !important;
}

.card_table .table.table-bordered.table-striped {
  margin-top: 30px;
}

.card_table .table_filter .form-control {
  padding: 5px 10px !important;
  height: 40px !important;

}

.card_table .input-group.asrt-page-length .form-control {
  padding: 5px 10px !important;
  height: 40px !important;
}

.card_table .col-md-6.float-right.text-right {

  margin-top: 0px;
}

/* .card_table .row.table-head.asrt-table-head {
  gap: 15px;
} */

/* end of table - 2 */

.file_name_wrapper {
  border: 1px solid #cde2e7 !important;
  border-radius: 8px !important;
  color: #3d565f !important;
  height: 54px !important;
  padding: 18px 20px !important;
  display: flex;
  align-items: center;
  font-size: 1rem;
  cursor: pointer;
}

/* new css */

.profileicon {
  color: #2d699b;
}

.profileicon svg, .profileicon img {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 50px;
}

.header .main-header .header-left .header-right {
  padding: 15px 0 15px 0px;
}

div.ruby-wrapper {
  /* width: 780px; */
  /* width: 800px; */
}

.formbtn:focus {
  box-shadow: none;
}

.btn.MuiButton-text {
  min-width: auto;
  font-size: 22px;
  padding-left: 12px;
  padding-right: 10px;
}

.btn.MuiButton-text:hover {
  background-color: transparent;
}

.alllogin .form-control {
  padding-left: 7px !important;
  padding-right: 7px !important;
  width: 100% !important;
  max-width: 60px;
}

.form-control__control {
  padding: 0 !important;
}

.form-control__control--menu-is-open,
.form-control__control--is-focused {
  box-shadow: 0 0 0 1px #06d6a0 !important;
}

.form-control__input-container {
  border: 0 !important;
  margin: 0 !important;
  padding: 14px 20px !important;
}

.form-control__value-container {
  padding: 0 !important;
  margin: 0 !important;
}

.form-control__single-value {
  padding: 0px 20px;
}

.custom_uploadBtn video {
  display: block;
  margin-bottom: 15px;
}

.PhoneInputInput {
  border: 0;
  outline: 0;
  padding: 12px 0px;
}

.customer-reset-password {
  padding-top: 130px;
  padding-bottom: 60px;
}

.boxbg {
  background-color: #e9ecef;
  border: 1px solid #cde2e7;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 24px;
}





/* new css */





.head_profile_wrapper {
  transition: all 0.3s ease;
}

.profile_dropdown_menus {
  content: '';
  /* position: absolute;
  width: 200px;
  height: 30px;
  background: red;
  top: 50px;
  transition: transform 0.3s ease; */
}

.profileicon:hover .profile_dropdown_menus {

  content: '';
  width: 200px;
  height: 30px;
  background: red;
  top: 50px;
  /* transition: transform 0.3s ease; */
}

.header_profile_wrapper ul,
.header_profile_wrapper li {
  list-style-type: none;
  padding-left: 0;
}

.header_profile_wrapper ul.ruby-menu .profile_dropdowns li button {
  background: #fff;
  color: #666;
  font-weight: 600;
  line-height: 40px;
  padding: 0 35px 0 25px;
  font-size: 14px;
}

.header_profile_wrapper ul.ruby-menu .profile_dropdowns li button {
  background: #fff;
  color: #666;
  font-weight: 600;
  line-height: 40px;
  padding: 0 35px 0 25px;
  font-size: 14px;
}

.header_profile_wrapper ul.ruby-menu .profile_dropdowns li:hover {
  background: #efefef;

}

.btn_max_width{
  max-width: 200px;
}

/* media */

@media (min-width:450px) {
  .custom_section {
    padding-top: 90px;
  }
}

@media (min-width:576px) {
  .custom_section {
    padding-top: 105px;
  }

  .support_search_wrapper input {

    font-size: 16px;
  }
}

@media screen and (min-width:768px) {
  .support_title {
    font-size: 20px;
  }

  .faq_cms_section h5 {
    font-size: 20px;
  }

  .card_table .col-md-6.float-right.text-right {
    display: flex;
    justify-content: end;
  }

  /* ul.ruby-menu>li>ul {
    transform: translateY(45px);
    transition: all 0.3s ease;
  }
   
   .header_profile_wrapper ul.ruby-menu>li:hover>ul {
    transform: translateY(10px);
  } */
}



@media (min-width:1200px) {
  .custom_section {
    padding-top: 97px;
  }

  .header_profile_wrapper {
    display: block !important;
  }

  .get_start_button {
    display: block !important;
  }
}

@media (max-width: 768px) {

  .card_table .row.table-foot.asrt-table-foot .col-md-6:first-child {
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
  }

  .card_table .row.table-foot.asrt-table-foot .col-md-6:nth-child(2) {
    display: flex;
    justify-content: center;
  }

  .card_table .col-md-6.float-right.text-right {
    margin-top: 10px;
  }

}

@media (max-width:400px) {

  .card_table .row.table-foot.asrt-table-foot .col-md-6:first-child {
    font-size: 13px;
    display: flex;
    justify-content: center;
  }

  .card_table .row.table-foot.asrt-table-foot .col-md-6:nth-child(2) {
    font-size: 13px;
    display: flex;
    justify-content: center;
  }

  .card_table .row.table-foot.asrt-table-foot .pagination .page-link {
    font-size: 13px;
    padding-left: 6px;
    padding-right: 6px;
  }

  .card_table .row.table-foot.asrt-table-foot .pagination .page-link input {
    font-size: 13px;
  }
}

@media screen and (min-width:360px) and (max-width: 575px) {
  .chatlist {
    width: 350px;
    right: 10px;
  }

  .chatbox {
    bottom: 5%;
  }
}

@media screen and (min-width:320px) and (max-width: 359px) {
  .chatlist {
    width: 310px;
    right: 6px;
  }

  .box_left,
  .box_right {
    width: 260px;
    min-width: 260px;
  }

  .chatbox {
    bottom: 5%;
  }
}



/* end of hariharan css */




.mob-accordion .accordion-button{
  padding: 0.5rem 0.6rem;
}
.mob-accordion .accordion-item{
  background-color: transparent;
  border: 1px solid transparent;
}
.mob-accordion a{
  text-decoration: none;
  cursor: pointer;
  color: #2d699b;
  font-weight: 600;
}
.mob-accordion a:hover{
  color: #06D6A0;
}
.mob-accordion .accordion-button:focus, .mob-accordion .accordion-button:not(.collapsed){
  border-color: transparent;
  background-color: transparent;
  box-shadow: unset;
}
.mob-accordion .subaccitem{
  margin-bottom: 10px;
}


.first_head{
  background-color: #2d699b;
  height: 50px;
}
.first_head a{
  color: #fff;
  text-decoration: none;
}
.first_head a:hover{
  color: #fff;
}

/* phoneInputCom */
.phoneInputCom *{
  /* border: 1px solid #ff0000 !important; */
}
option{
  border: 40px solid red !important;
}
span.tft:hover {
  color: #d83d10;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;;;cAGY;EACZ,eAAe;EACf,YAAY;EACZ,SAAS;EACT,SAAS;EACT,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;IACX,gBAAgB;AACpB;AACA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,eAAe;EACf;;;;;;kBAMgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;4BAE0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB;sBACoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;EAGlB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,6BAA6B;AACjC;AACA;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mBAAmB;;AAEnB,WAAW;AACX;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;;;AAIA,gBAAgB;AAChB;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,QAAQ;EACR,sBAAsB;EACtB,uCAAuC;EACvC,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,UAAU;EACV,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;EAEE,oDAAoD;EACpD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,gCAAgC;AAClC;;AAEA,aAAa;;;;AAIb;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,mBAAmB;;AAEnB,eAAe;AACf;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oEAAsE;EACtE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE;IACE,6CAA6C;EAC/C;;EAEA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,aAAa;EACb,WAAW;EACX,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,yDAA0C;AAC5C;AACA;;GAEG;AACH;;IAEI,aAAa;IACb,wBAAwB;AAC5B;AACA;EACE,yDAA2C;AAC7C;;AAEA;EACE,yDAA8C;AAChD;;AAEA;EACE,yDAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,sCAAsC;EACtC,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;;EAEE,sCAAsC;EACtC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;;;EAIE,yBAAyB;AAC3B;AACA;IACI,sDAAsD;IACtD,wBAAwB;IACxB,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;EACE,sCAAsC;AACxC;AACA;;EAEE,gCAAgC;EAChC,+CAA+C;EAC/C,oEAA0D;EAC1D,uCAAuC;EACvC,4EAA4E;EAC5E,wCAAwC;EACxC,2EAA2E;AAC7E;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,gCAAgC;EAChC,4DAA4D;AAC9D;;AAEA;;EAEE,gCAAgC;EAChC,+CAA+C;EAC/C,oEAAuD;EACvD,uCAAuC;EACvC,sEAAsE;EACtE,2EAA2E;AAC7E;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,gCAAgC;EAChC,4DAA4D;AAC9D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,yDAA0C;AAC5C,yCAAyC;AACzC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;;AAEA;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;AACA;;AAEA;GACG;IACC,QAAQ;IACR,SAAS;GACV;AACH;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,QAAQ;IACR,SAAS;EACX;CACD;EACC,cAAc;CACf;CACA;EACC,kBAAkB;CACnB;AACD;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,QAAQ;IACR,SAAS;EACX;AACF;;;AAGA;;EAEE;;IAEE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,QAAQ;IACR,SAAS;EACX;AACF;AACA;EACE;IACE;;uBAEmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,6DAAoD;IACpD,WAAW;IACX,YAAY;IACZ,SAAS;IACT,aAAa;EACf;;EAEA;IAKE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;;;IAGE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;;;IAGE,0BAA0B;IAC1B,qBAAqB;IACrB,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,aAAa;EACf;;EAEA;;;IAGE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;;;IAGE;;eAEW;IACX,WAAW;IACX,6DAAoD;IACpD,WAAW;IACX,YAAY;IACZ,SAAS;IACT,SAAS;IACT,aAAa;;EAEf;;EAEA;;;IAOE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;;;IAGE,yBAAyB;EAC3B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;;IAGE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;IACR,SAAS;EACX;EACA;IACE,cAAc;GACf;;GAEA;;MAEG;AACN;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,UAAU;AACd;EACE;IACE,mBAAmB;IACnB,UAAU;AACd;AACA;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;AACpB;EACE;IACE,kBAAkB;GACnB;EACD;IACE,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,0CAA0C;IAC1C,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;;AAEA;;EAEE;;;IAGE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;KAEG;EACH;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,kCAAkC;;AAElC;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;;AAGA,2BAA2B;;AAE3B;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wBAAwB;;AAExB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,oCAAoC;EAEpC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAE9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EAGE,2BAA2B;EAC3B,0BAA0B;;AAE5B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,qBAAqB;;AAErB;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;;AAGA,uBAAuB;;AAEvB,sBAAsB;;AAEtB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;EACZ,2CAA2C;EAC3C,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;;AAEzB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;GAEG;;AAEH,qBAAqB;;AAErB;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA,YAAY;;AAEZ;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;;;;;AAMA,YAAY;;;;;;AAMZ;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX;;;;;oCAKkC;AACpC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,SAAS;EACT,qCAAqC;AACvC;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;;AAErB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,UAAU;;AAEV;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;;;;;;;KAOG;AACL;;;;AAIA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE;IACE,mBAAmB;IACnB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;;EAEE;IACE,eAAe;IACf,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;AACF;;;;AAIA,yBAAyB;;;;;AAKzB;EACE,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,0CAA0C;AAC5C;AACA;EACE,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800&display=swap\");\n\nbody {\n  font-family: \"Manrope\", sans-serif !important;\n}\n\nh5 {\n  font-weight: 700;\n}\n\nh2 {\n  font-size: 48px;\n  line-height: 56px;\n  font-weight: 700;\n}\n.gtranslate_wrapper{\n  /* position: fixed;\n  z-index: 999;\n  right: 9%;\n  top: 20px; */\n  position: fixed;\n  z-index: 999;\n  left: 16%;\n  top: 15px;\n  display: flex;\n}\na.glink img{\n  height: 24px !important;\n  width: 24px !important;\n}\na.gt_switcher-popup.glink, .gt_switcher-popup span{\n  color: #fff !important;\n  display: flex;\n  align-items: center;\n  /* gap: 4px; */\n  padding-left: 5px;\n}\n.labelname{\n  font-weight: 600;\n}\n.color-grey-500 {\n  color: #3d565f;\n}\n.hset{\n  height: 460px;\n    overflow-y: auto;\n}\n.alllogin input {\n  width: 2.4em !important;\n  height: 2.4em;\n}\n\n.alllogin span {\n  margin: 0px 8px !important;\n}\n\n.error-msg {\n  margin-top: 8px;\n  margin-left: 5px;\n  font-size: 15px;\n  color: red;\n  text-align: start !important;\n}\n\n/* header css */\n.burger-icon {\n  cursor: pointer;\n  /* position: absolute;\n  height: 20px;\n  right: 0;\n  top: 10px;\n  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n  width: 24px;\n  z-index: 1004; */\n  font-size: 30px;\n  margin-top: -5px;\n}\n.profile_dropdowns{\n  right: 0;\n}\n\n.header .burger-icon {\n  display: none;\n}\n\n.burger-icon {\n  top: 22px;\n}\n\n.burger-icon.burger-close {\n  width: 15px;\n}\n\n.burger-icon>span {\n  display: block;\n  height: 2px;\n  left: 0;\n  position: absolute;\n  width: 100%;\n}\n\n.burger-icon>span.burger-icon-top {\n  top: 2px;\n}\n\n.burger-icon>span.burger-icon-bottom {\n  bottom: 2px;\n}\n\n.burger-icon>span.burger-icon-mid {\n  top: 9px;\n}\n\n.burger-icon.burger-close {\n  position: fixed;\n  right: 30px;\n  top: 16px;\n}\n\n.burger-icon.burger-close>span.burger-icon-top {\n  display: none;\n  opacity: 0;\n}\n\n.burger-icon.burger-close>span.burger-icon-mid {\n  top: 8px;\n  transform: rotate(45deg);\n}\n\n.burger-icon.burger-close>span.burger-icon-bottom {\n  bottom: 10px;\n  transform: rotate(-45deg);\n}\n\n.burger-icon>span:after,\n.burger-icon>span:before {\n  background-color: #333;\n  content: \"\";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.burger-icon.burger-icon-white>span:after,\n.burger-icon.burger-icon-white>span:before {\n  background-color: #3d565f;\n}\n\n.burger-icon.burger-close.burger-icon-white>span:after,\n.burger-icon.burger-close.burger-icon-white>span:before {\n  background-color: var(--primary-color);\n}\n\n.btn.close {\n  font-size: 22px;\n  color: #2d699b;\n}\n\n.offcanvas-header {\n  border-bottom: 1px solid #cde2e7;\n}\n\n.offcanvas-header .logos {\n  max-width: 60%;\n}\n\n.fw-700 {\n  font-weight: 700;\n}\n\n.offcanvas-body {\n  /* display: flex;\n  align-items: center;\n  justify-content: center; */\n}\n\n.offcanvas-body h4 {\n  color: #2d699b;\n  text-align: center;\n}\n\n.header {\n  border-bottom: 1px solid #b9cad0;\n  background-color: #fff;\n  float: left;\n  padding: 0;\n  /* position: relative; */\n  width: 100%;\n  position: fixed;\n  z-index: 777;\n  top: 0;\n}\n\n.kXOQrs {\n  justify-content: start !important;\n}\n.hChFUv {\n  justify-content: start !important;\n}\n\n.header .main-header {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n}\n\n.header .main-header .header-left {\n  align-items: center;\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n.font-sm{\n  font-size: 14px;\n  line-height: 18px;\n}\n.color-grey-400{\n  color: #4e6770 !important;\n}\n.header .main-header .header-left .header-logo {\n  max-width: 150px;\n  width: 100%;\n}\n\n.header .main-header .header-left .header-logo a {\n  display: block;\n}\n\n.header .main-header .header-left .header-logo a img {\n  min-height: 37px;\n  max-width: 100%;\n}\n\n.header .main-header .header-left .header-nav {\n  display: inline-block;\n  text-align: left;\n  /* width: 75%;\n  margin-left: 25px; */\n}\n\n.header .nav-main-menu {\n  float: none;\n  padding: 0;\n  width: auto;\n}\n\ndiv.ruby-menu-demo-header {\n  position: relative;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: auto;\n  padding: 0;\n  margin: 0;\n  z-index: 9999;\n}\n\ndiv.ruby-wrapper {\n  position: relative;\n  /* width: 780px; */\n  height: 50px;\n  margin: 0 auto;\n  background: #fff;\n}\n\ndiv.ruby-wrapper,\ndiv.ruby-wrapper.ruby-vertical {\n  /* background: #f9f9f9; */\n  color: #222;\n}\n\ndiv.ruby-wrapper ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\ndiv.ruby-wrapper>ul {\n  position: relative;\n}\n\nul.ruby-menu>li {\n  float: left;\n  font-size: 14px;\n}\n\nul.ruby-menu>li>a {\n  display: block;\n  line-height: 50px;\n  padding: 0 15px 0 15px;\n  color: #071920;\n  text-decoration: none;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 500;\n  position: relative;\n}\n\nul.ruby-menu>li>a:hover,\nul.ruby-menu>li:hover>a,\nul.ruby-menu>li.ruby-active-menu-item>a:hover,\nul.ruby-menu>li.ruby-active-menu-item:hover>a {\n  background: #2d699b;\n}\n\nul.ruby-menu>li>a:hover,\nul.ruby-menu>li:hover>a,\nul.ruby-menu>li.ruby-active-menu-item>a:hover,\nul.ruby-menu>li.ruby-active-menu-item:hover>a {\n  /* background: #222; */\n  color: #fff;\n}\n\nul.ruby-menu>li>ul,\nul.ruby-menu>li>ul>li>ul,\nul.ruby-menu>li>ul>li>ul>li>ul {\n  position: absolute;\n  -webkit-box-shadow: 0 8px 24px -5px #ccc;\n  -moz-box-shadow: 0 8px 24px -5px #ccc;\n  box-shadow: 0 8px 24px -5px #ccc;\n  border-top: 4px solid #2d699b;\n}\n\nul.ruby-menu>li>ul>li,\nul.ruby-menu>li>ul>li>ul>li {\n  position: relative;\n}\n\nul.ruby-menu>li>ul>li>a,\nul.ruby-menu>li>ul>li>ul>li>a,\nul.ruby-menu>li>ul>li>ul>li>ul>li>a {\n  display: block;\n  width: 250px;\n  line-height: 40px;\n  padding: 0 35px 0 25px;\n  background: #fff;\n  color: #666;\n  text-decoration: none;\n  font-size: 14px;\n}\n.FooterHeadquater{\n  color: black;\n  transition: all .3s ease 0s;\n}\n.FooterHeadquater:hover {\n  color: #f15f34;\n}\n\nul.ruby-menu>li>ul>li>a,\nul.ruby-menu>li>ul>li>ul>li>a,\nul.ruby-menu>li>ul>li>ul>li>ul>li>a {\n  background: #fff;\n  color: #666;\n  font-weight: 600;\n}\n\nul.ruby-menu>li>ul>li>a:only-child:after,\nul.ruby-menu>li>ul>li>ul>li>a:only-child:after,\nul.ruby-menu>li>ul>li>ul>li>ul>li>a:only-child:after {\n  content: \"\";\n}\n\nspan.ruby-dropdown-toggle {\n  transition: transform 0.3s ease;\n}\n\nul.ruby-menu>li>ul>li:hover>a,\nul.ruby-menu>li>ul>li>a:hover,\nul.ruby-menu>li>ul>li>ul>li:hover>a,\nul.ruby-menu>li>ul>li>ul>li>a:hover,\nul.ruby-menu>li>ul>li>ul>li>ul>li:hover>a,\nul.ruby-menu>li>ul>li>ul>li>ul>li>a:hover {\n  background: #efefef;\n}\n\nul.ruby-menu>li>ul>li>ul,\nul.ruby-menu>li>ul>li>ul>li>ul {\n  left: 250px;\n  top: -4px;\n  z-index: 100;\n}\n\nul.ruby-menu>li>ul>li.ruby-open-to-left>ul,\nul.ruby-menu>li>ul>li>ul>li.ruby-open-to-left>ul {\n  left: auto;\n  right: 250px;\n}\n\n.header .main-header .header-left .header-right {\n  padding: 15px 0 15px 15px;\n  text-align: right;\n  /* width: 40%; */\n}\n\n.btn.btn-brand-1 {\n  background: #2d699b;\n  border-radius: 4px;\n  color: #ffe7bb;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 18px;\n  padding: 15px 24px;\n  width: 100%;\n  max-width: 140px;\n}\n@media (min-width:1200px) and (max-width:1399px) {\n  .header-right .get_start_button .btn.btn-brand-1 {\n    padding: 15px 24px !important; \n}\n}\n.btn.btn-brand-1:hover {\n  background-color: #d83d10;\n  color: #ffe7bb;\n}\n\n/* header css end */\n\n/* footer */\nimg {\n  max-width: 100%;\n  transition: all 0.3s ease 0s;\n}\n\nh6 {\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 700;\n}\n\n.mb-10 {\n  margin-bottom: 10px !important;\n}\n\n.mt-15 {\n  margin-top: 15px !important;\n}\n\na:hover {\n  color: #f05a2d;\n}\n\n.icon-socials {\n  background-size: contain !important;\n  display: inline-block;\n  height: 21px;\n  margin-right: 8px;\n  transition-duration: 0.2s;\n  vertical-align: middle;\n  width: 21px;\n}\n\n.icon-socials:hover {\n  transform: translateY(-3px);\n  transition-duration: 0.2s;\n}\n\nfooter {\n  display: block;\n}\n\n.footer-1 {\n  background-color: #fff;\n  margin: 0;\n  padding: 90px 0 25px;\n}\n\nfooter a {\n  text-decoration: none;\n}\n\n.color-brand-1 {\n  color: #2d699b !important;\n}\n\n.footer .width-20 {\n  width: 20%;\n}\n\n.footer .width-25 {\n  width: 25%;\n}\n\n.footer .width-22 {\n  width: 22%;\n}\n\n.footer .width-23 {\n  width: 23%;\n}\n\n.footer .width-16 {\n  width: 19%;\n}\n\n.footer .menu-footer {\n  display: inline-block;\n}\n\n.footer .menu-footer li {\n  list-style: none;\n  margin-bottom: 8px;\n}\n\n.footer .menu-footer li a {\n  color: #4e6770;\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  padding: 0;\n  text-decoration: none;\n  transition-duration: 0.2s;\n}\n\n.footer .menu-footer li a:hover {\n  color: var(--primary-color);\n  padding-left: 2px;\n  transition-duration: 0.2s;\n}\n\n.footer .footer-bottom {\n  border-top: 1px solid #6a838c;\n  color: #3d565f;\n  font-size: 14px;\n  padding: 30px 0;\n}\n\n.footer .menu-footer {\n  display: inline-block;\n  padding: 0;\n}\n\n.footer .menu-footer li {\n  list-style: none;\n  margin-bottom: 8px;\n}\n\n.footer .menu-footer li a {\n  color: #4e6770;\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  padding: 0;\n  text-decoration: none;\n  transition-duration: 0.2s;\n}\n\n.footer .menu-footer li a:hover {\n  color: #2d699b;\n  padding-left: 2px;\n  transition-duration: 0.2s;\n}\n\n.footer-custom {\n  background-color: #0e2130;\n  display: inline-block;\n  padding: 0;\n  position: relative;\n  width: 100%;\n}\n\n.footer .footer-bottom {\n  border-top: 1px solid #ecf1f2;\n  color: #3d565f;\n  font-size: 14px;\n  padding: 30px 0;\n}\n\n.font-md {\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 24px !important;\n}\n\n.color-grey-300 {\n  color: #6a838c;\n}\n\n#scrollUp,\n.footer .footer-bottom a {\n  text-decoration: none;\n}\n\n#scrollUp {\n  position: fixed;\n  background-color: #fff;\n  background-color: #2d699b;\n  border: 0;\n  border-radius: 8px;\n  bottom: 20px;\n  color: #fff;\n  height: 56px;\n  overflow: hidden;\n  right: 20px;\n  text-align: center;\n  transition-duration: 0.2s;\n  width: 56px;\n  z-index: 999 !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n\n\n/* chart start */\n.chatbox {\n  position: fixed;\n  bottom: 5%;\n  right: 20px;\n  background-color: #2d699b;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  z-index: 999 !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.chatbox svg {\n  fill: #fff;\n}\n\n.chatlist {\n  position: fixed;\n  right: 80px;\n  bottom: 12%;\n  height: 550px;\n  width: 400px;\n  overflow: hidden;\n  border: 1px solid #fff;\n  background-color: #fff;\n  z-index: 1050;\n  border-radius: 8px;\n  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n}\n\n.pos {\n  position: relative;\n  z-index: 3;\n}\n\n.wrapss {\n  display: flex;\n  /* flex-wrap: wrap; */\n  overflow: auto;\n  gap: 4px;\n  background-color: #fff;\n  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n  /* margin: 0px 8px 6px 8px; */\n  padding: 4px 4px;\n  position: absolute;\n  width: 96%;\n  left: 0;\n  z-index: 5;\n  bottom: 12%;\n}\n\n.textbreak {\n  word-wrap: break-word;\n}\n\n.widthset {\n  width: 90px;\n  min-width: 90px;\n  background: #00000017;\n  /* margin: auto; */\n  text-align: center;\n  border-radius: 4px;\n  word-wrap: break-word;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #98bfded6;\n}\n\n.closeicon {\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  top: 1px;\n  right: 1px;\n  color: #000;\n  cursor: pointer;\n}\n\n.chatimage {\n  width: 100px;\n  height: 100px;\n  object-fit: contain;\n}\n\n.uploadlogos {\n  width: 70px;\n  height: 70px;\n  object-fit: contain;\n}\n\n.chat_head {\n  background-color: #2d699b;\n  color: #fff;\n  padding: 10px 20px;\n  text-align: center;\n}\n\n.chattext_box {\n  padding: 14px 8px;\n  height: 440px;\n  min-height: 440px;\n  overflow-y: auto;\n}\n\n.box_left {\n  width: 300px;\n  min-width: 300px;\n  background-color: #ffe7bb;\n  padding: 10px;\n  border-radius: 4px;\n  color: #000;\n  position: relative;\n  z-index: 2;\n}\n\n.box_right {\n  width: 300px;\n  min-width: 300px;\n  background-color: #2d699b;\n  padding: 10px;\n  border-radius: 4px;\n  color: #fff;\n  margin-left: auto;\n  position: relative;\n  z-index: 2;\n}\n\n.btn.btn-brand-1.sendbtn {\n  padding: 8px 10px;\n  height: 54px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.btn.btn-brand-1.sendbtn svg {\n  font-size: 25px;\n}\n\n.chatlist input {\n  color: #000 !important;\n  font-weight: 500 !important;\n}\n\n.chattext_box::-webkit-scrollbar-track,\n.wrapss::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #F5F5F5;\n}\n\n.chattext_box::-webkit-scrollbar,\n.wrapss::-webkit-scrollbar {\n  width: 9px;\n  height: 5px;\n  background-color: #F5F5F5;\n}\n\n.chattext_box::-webkit-scrollbar-thumb,\n.wrapss::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);\n  background-color: #2d699b;\n}\n\n.cursor {\n  cursor: pointer;\n}\n\n.full_list {\n  padding-top: 20%;\n  text-align: center;\n}\n\n.full_list .btn {\n  width: 250px;\n  min-width: 250px;\n  margin: auto;\n}\n\n.otplist div {\n  justify-content: center;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.otplist input {\n  width: 2.5em !important;\n  height: 2.5em !important;\n}\n\n.img_head {\n  width: 120px;\n}\n\n.fw-600 {\n  font-weight: 600;\n}\n\n.timepos {\n  position: absolute;\n  bottom: 2px;\n  right: 7px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.playpos {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  font-size: 28px;\n  transform: translate(-50%, -50%);\n}\n\n/* chat end */\n\n\n\n#scrollUp i {\n  color: #fff;\n  display: block;\n  font-size: 20px;\n  line-height: 56px !important;\n}\n\n#scrollUp:hover {\n  background-color: #d83d10;\n  transform: translateY(-3px);\n  transition-duration: 0.2s;\n}\n\n.footer .width-16,\n.footer .width-20 {\n  margin-bottom: 20px;\n}\n\n/* footer css end */\n\n/* inner page */\n.box-newsletter {\n  border-radius: 0;\n  background-color: #96bfe0;\n  border-radius: 8px;\n  display: inline-block;\n  padding: 40px;\n  position: relative;\n  width: 100%;\n}\n\n.box-newsletter:before {\n  background: url(\"./Assets/newsletter_finger_top.png\") no-repeat 100% 0;\n  background-size: cover;\n  content: \"\";\n  height: 100px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 111px;\n}\n\n.box-newsletter .box-image-newsletter {\n  position: relative;\n}\n\n.box-newsletter .image-1 {\n  bottom: -45px;\n  left: 0;\n  position: absolute;\n}\n\n.shape-2 {\n  animation: hero-thumb-sm-animation 4s linear infinite alternate;\n}\n\n@keyframes hero-thumb-sm-animation {\n  0% {\n    transform: translateY(-20px) translateX(50px);\n  }\n\n  100% {\n    transform: translateY(-20px) translateX(0);\n  }\n}\n\n.font-lg {\n  font-size: 18px;\n  line-height: 23px;\n  font-weight: 500;\n}\n\n.box-newsletter .form-newsletter {\n  background: #fff;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n.box-newsletter .form-newsletter form {\n  display: flex;\n}\n\n.box-newsletter .form-newsletter form input {\n  border: 0;\n  box-shadow: none;\n  color: #071920;\n  outline: 0;\n  padding: 10px;\n  width: 100%;\n  transition: all 0.3s ease 0s !important;\n  font-size: 14px;\n}\n\n.btn.btn-submit-newsletter {\n  background-color: #2d699b;\n  border-radius: 8px;\n  padding: 15px 16px 16px;\n}\n\n.box-newsletter .img-main {\n  border-radius: 565px;\n  max-width: 100%;\n  width: 100%;\n}\n\n.btn.btn-submit-newsletter:hover {\n  background-color: #d83d10;\n}\n\n.btn.btn-submit-newsletter svg {\n  color: #fff;\n}\n\n.section {\n  display: inline-block;\n  width: 100%;\n  padding-top: 50px;\n}\n\n.font-md {\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 24px !important;\n}\n\n.box-page-register {\n  border-bottom: 1px solid #cde2e7;\n  padding-bottom: 110px;\n  position: relative;\n}\n\n.box-page-register:before {\n  background-color: #e0f1f4;\n  content: \"\";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 33%;\n  z-index: 1;\n}\n\n.box-page-register .container {\n  position: relative;\n  z-index: 2;\n}\n\n.box-steps-small {\n  padding-left: 90px;\n  padding-right: 150px;\n  padding-top: 200px;\n}\n\n.box-steps-small .item-number {\n  cursor: pointer;\n  margin-bottom: 30px;\n}\n\n.item-number {\n  display: flex;\n  /* margin-bottom: 40px; */\n  position: relative;\n}\n\n.hover-up,\n.hover-up:hover {\n  transition: all 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);\n}\n\n.hover-up:hover {\n  transform: translateY(-2px);\n}\n\n.box-steps-small .item-number.active .num-ele,\n.box-steps-small .item-number:hover .num-ele {\n  background-color: #06d6a0;\n}\n\n.item-number .num-ele {\n  background-color: #2d699b;\n  border-radius: 50%;\n  color: #ffe7bb;\n  font-size: 48px;\n  font-weight: 700;\n  height: 83px;\n  line-height: 83px;\n  margin-right: 20px;\n  max-width: 83px;\n  min-width: 83px;\n  text-align: center;\n  width: 83px;\n}\n\n.box-steps-small .item-number .num-ele {\n  font-size: 26px;\n  height: 48px;\n  line-height: 48px;\n  max-width: 48px;\n  min-width: 48px;\n  width: 48px;\n}\n\n.item-number .info-num {\n  width: 100%;\n}\n\n.box-steps-small .item-number .info-num h5 {\n  margin-bottom: 8px !important;\n}\n\n.box-register {\n  padding: 100px 130px 0 0;\n}\n\n.form-control,\n.form-control__input-container,\n.form-control__control {\n  border: 1px solid #cde2e7 !important;\n  border-radius: 8px !important;\n  color: #3d565f !important;\n  height: 54px !important;\n  padding: 18px 20px !important;\n}\n.gt_container-unisv1 a.glink span{\n  margin-right: 7px !important;\n  font-size: 15px !important;\n  vertical-align: middle;\n}\n.icon-name {\n  background-image: url(\"./Assets/name.svg\");\n}\n/* .date_class.icon-name {\n  background-image: unset !important;\n} */\ninput[type=\"date\"]::-webkit-inner-spin-button,\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n    display: none;\n    -webkit-appearance: none;\n}\n.icon-email {\n  background-image: url(\"./Assets/email.svg\");\n}\n\n.icon-password {\n  background-image: url(\"./Assets/password.svg\");\n}\n\n.icon-gender {\n  background-image: url(\"./Assets/user.svg\");\n}\n\n.form-control.icon-password {\n  background-image: unset;\n}\n\n.eyepassword {\n  position: absolute;\n  top: 25%;\n  font-size: 20px;\n  right: 3%;\n  color: #757d85;\n  cursor: pointer;\n}\n\n.icon-name,\n.icon-password {\n  background-position: right 15px center;\n  background-repeat: no-repeat;\n  padding-right: 40px !important;\n}\n\n.icon-email,\n.icon-user {\n  background-position: right 15px center;\n  background-repeat: no-repeat;\n  padding-right: 40px;\n}\n\n.icon-gender {\n  background-position: right 15px center;\n  background-repeat: no-repeat;\n  padding-right: 40px;\n}\n\n.is-valid~.valid-feedback,\n.is-valid~.valid-tooltip,\n.was-validated :valid~.valid-feedback,\n.was-validated :valid~.valid-tooltip {\n  display: block !important;\n}\n.dwfkuc {\n    border-bottom: 1px solid rgba(0, 0, 0, .12) !important;\n    border-top: 0 !important;\n    border-left: 0 !important;\n    border-right: 0 !important;\n    font-weight: 700;\n}\n.ehdHJD{\n  justify-content: flex-start !important;\n}\n.form-control.is-valid,\n.was-validated .form-control:valid {\n  border-color: #198754 !important;\n  padding-right: calc(1.6em + 0.75rem) !important;\n  background-image: url(\"./Assets/greensign.svg\") !important;\n  background-repeat: no-repeat !important;\n  /* background-position: right calc(0.375em + 0.1875rem) center !important; */\n  background-position: 97% 20px !important;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;\n}\n\n.form-control.icon-password.is-valid,\n.was-validated .form-control.icon-password:valid {\n  background-image: unset !important;\n}\n\n.form-control.is-valid:focus,\n.was-validated .form-control:valid:focus {\n  border-color: #198754 !important;\n  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25) !important;\n}\n\n.form-control.is-invalid,\n.was-validated .form-control:invalid {\n  border-color: #dc3545 !important;\n  padding-right: calc(1.5em + 0.75rem) !important;\n  background-image: url(\"./Assets/wrongi.svg\") !important;\n  background-repeat: no-repeat !important;\n  background-position: right calc(0.375em + 0.1875rem) center !important;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;\n}\n\n.form-control.icon-password.is-invalid,\n.was-validated .form-control.icon-password:invalid {\n  background-image: unset !important;\n}\n\n.form-control.is-invalid:focus,\n.was-validated .form-control:invalid:focus {\n  border-color: #dc3545 !important;\n  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25) !important;\n}\n\n.form-control:focus {\n  border-color: #06d6a0 !important;\n}\n\n[type=\"text\"].form-control:focus,\ninput.form-control:focus,\ninput[type=\"text\"]:focus {\n  box-shadow: unset !important;\n}\n\n.cb-container {\n  display: flex;\n  align-items: center;\n}\n\n.cb-container input {\n  width: 23px;\n  height: 24px;\n}\n\n.cb-container .text-small {\n  color: #3d565f;\n  font-weight: 500;\n}\n\n.form-check-input:checked {\n  background-color: #06d6a0 !important;\n  border: 1px solid #06d6a0 !important;\n}\n\n.form-check-input:focus {\n  box-shadow: unset !important;\n}\n\n.btn.btn-brand-lg {\n  background: #2d699b;\n  border-radius: 8px;\n  color: #ffe7bb;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 18px;\n  /* padding: 20px 24px; */\n  padding: 10px 24px;\n}\n\n.btn.btn-full {\n  width: 100%;\n}\n\n.btn.btn-brand-lg:hover {\n  background-color: #d83d10;\n}\n\n.color-success {\n  color: #06d6a0;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.banner-login {\n  height: 600px;\n}\n\n.box-banner-abs {\n  left: 0;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n}\n\n.icon-user {\n  background-image: url(\"./Assets/user.svg\");\n/* background-position: 0 0 !important; */\n}\n\n.customer-reset-password {\n  padding-top: 90px;\n}\n.MobileAccordionTitle:hover {\n  color: #2adcae !important;\n}\n\n@media screen and (min-width:1400px) {\ndiv.ruby-wrapper {\n  /* width: 900px !important; */\n}\nul.ruby-menu>li>a {\n  padding: 0 22px 0 25px;\n}\n}\n\n@media screen and (min-width:1400px) and (max-width:1799px) {\n   .gtranslate_wrapper{\n    left: 7%;\n    top: 15px;\n   }\n}\n\n@media (max-width: 1399.98px) {\n  .box-steps-small {\n    padding-left: 0;\n    padding-right: 50px;\n    padding-top: 180px;\n  }\n\n  .box-register {\n    padding-right: 0;\n  }\n\n  .box-banner-login {\n    margin: auto;\n    max-width: 450px;\n  }\n\n  .box-banner-abs {\n    left: auto;\n    position: relative;\n    top: auto;\n    transform: none;\n  }\n\n  .banner-login .box-banner-abs {\n    top: 40%;\n    transform: translateY(-40%);\n  }\n\n  .banner-login .box-banner-abs {\n    padding: 60px 0;\n    top: auto;\n    transform: none;\n  }\n\n  .box-steps-small .item-number{\n    width: 80%;\n  }\n}\n\n@media screen and (min-width:1200px) and (max-width:1399px) {\n  .gtranslate_wrapper {\n    left: 3%;\n    top: 15px;\n  }\n .header .container{\n  max-width: 98%;\n }\n .gset{\n  width: max-content;\n }\n}\n\n@media (max-width: 1199.98px) {\n  .header .burger-icon {\n    display: block;\n  }\n\n  .header .main-header .header-left .header-right {\n    padding-right: 40px;\n    text-align: right;\n    /* width: 100%; */\n  }\n\n  .header .header-right .btn.btn-brand-1 {\n    padding: 8px 16px;\n  }\n}\n\n@media screen and (min-width: 1140px) {\n  .customer-reset-password {\n    width: 50%;\n  }\n}\n\n@media screen and (min-width:992px) and (max-width:1199px) {\n  .gtranslate_wrapper {\n    left: 3%;\n    top: 15px;\n  }\n}\n\n\n@media screen and (max-width: 991.98px) {\n\n  .footer .width-16,\n  .footer .width-20 {\n    margin-bottom: 20px;\n  }\n  .footer .width-23 {\n    width: 100%;\n    margin-top: 10px;\n  }\n\n  .footer .width-16,\n  .footer .width-20 {\n    width: 50%;\n  }\n\n  .box-newsletter .box-image-newsletter {\n    margin-bottom: 40px;\n  }\n\n  .box-register,\n  .box-steps-small {\n    padding-top: 50px;\n  }\n\n  .box-page-register:before {\n    width: 100%;\n  }\n\n  h2 {\n    font-size: 36px;\n    line-height: 46px;\n  }\n\n  .box-steps-small .item-number{\n    width: 100%;\n  }\n}\n\n@media screen and (min-width:768px) and (max-width:991px) {\n  .gtranslate_wrapper {\n    left: 5%;\n    top: 15px;\n  }\n}\n@media screen and (min-width: 768px) {\n  ul.ruby-menu>li>a:after {\n    /* font-family: \"FontAwesome\";\n    text-decoration: none;\n    content: '\\f107'; */\n    content: \"\";\n    position: absolute;\n    margin-left: 0px;\n    background: url(\"./Assets/downarrows.png\") no-repeat;\n    width: 20px;\n    height: 20px;\n    top: 15px;\n    display: none;\n  }\n\n  ul.ruby-menu>li:hover>a:after {\n    -webkit-transform: rotate(-180deg);\n    -moz-transform: rotate(-180deg);\n    -o-transform: rotate(-180deg);\n    -ms-transform: rotate(-180deg);\n    transform: rotate(-180deg);\n    filter: invert(1);\n  }\n\n  ul.ruby-menu>li>ul,\n  ul.ruby-menu>li>ul>li>ul,\n  ul.ruby-menu>li>ul>li>ul>li>ul {\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  ul.ruby-menu>li>ul>li>a:after,\n  ul.ruby-menu>li>ul>li>ul>li>a:after,\n  ul.ruby-menu>li>ul>li>ul>li>ul>li>a:after {\n    font-family: \"FontAwesome\";\n    text-decoration: none;\n    font-size: 16px;\n    padding: 0;\n    content: \"\\f105\";\n    position: absolute;\n    right: 15px;\n    display: none;\n  }\n\n  ul.ruby-menu>li:hover>ul,\n  ul.ruby-menu>li>ul>li:hover>ul,\n  ul.ruby-menu>li>ul>li>ul>li:hover>ul {\n    visibility: visible;\n    opacity: 1;\n  }\n\n  ul.ruby-menu>li>ul>li.ruby-open-to-left>a:after,\n  ul.ruby-menu>li>ul>li>ul>li.ruby-open-to-left>a:after,\n  ul.ruby-menu>li>ul>li>ul>li>ul>li.ruby-open-to-left>a:after {\n    /* content: '\\f104';\n  right: auto;\n  left: 10px; */\n    content: \"\";\n    background: url(\"./Assets/left-arrow.png\") no-repeat;\n    width: 12px;\n    height: 12px;\n    left: 5px;\n    top: 14px;\n    display: none;\n\n  }\n\n  ul.ruby-menu>li>ul>li.ruby-open-to-left:hover>a:after,\n  ul.ruby-menu>li>ul>li>ul>li.ruby-open-to-left:hover>a:after,\n  ul.ruby-menu>li>ul>li>ul>li>ul>li.ruby-open-to-left:hover>a:after {\n    -webkit-transform: rotate(-180deg);\n    -moz-transform: rotate(-180deg);\n    -o-transform: rotate(-180deg);\n    -ms-transform: rotate(-180deg);\n    transform: rotate(-180deg);\n  }\n}\n\n@media screen and (min-width: 767px) {\n  ul.ruby-menu>li>a:after {\n    transition: all 0.3s ease;\n  }\n\n  ul.ruby-menu>li>ul,\n  ul.ruby-menu>li>div {\n    transform: translateY(25px);\n    transition: all 0.3s ease;\n  }\n\n  ul.ruby-menu>li>ul>li>a:after,\n  ul.ruby-menu>li>ul>li>ul>li>a:after,\n  ul.ruby-menu>li>ul>li>ul>li>ul>li>a:after {\n    transition: all 0.3s ease;\n  }\n\n  ul.ruby-menu>li:hover>ul,\n  ul.ruby-menu>li:hover>div {\n    transform: translateY(0);\n  }\n\n  ul.ruby-menu>li>ul>li.ruby-open-to-left:hover>ul,\n  ul.ruby-menu>li>ul>li>ul>li.ruby-open-to-left:hover>ul,\n  ul.ruby-menu>li>ul>li>ul>li>ul>li.ruby-open-to-left:hover>ul {\n    transform: translateX(0);\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .btn.btn-brand-1 {\n    padding: 15px 24px;\n  }\n  .gtranslate_wrapper {\n    left: 5%;\n    top: 15px;\n  }\n  .header .container{\n    max-width: 96%;\n   }\n   \n   /* .gset{\n    width: max-content;\n   } */\n}\n.profile_dropdowns{\n  background: #fff;\n}\n@media screen and (max-width: 767px) {\n  h2 {\n    font-size: 30px;\n    line-height: 40px;\n  }\n  ul.ruby-menu>li>ul.profile_dropdowns {\n    visibility: hidden;\n    opacity: 0;\n}\n  ul.ruby-menu>li:hover>ul.profile_dropdowns {\n    visibility: visible;\n    opacity: 1;\n}\n}\n\n@media (max-width: 575.98px) {\n  .mobfont{\n    font-size: 16px;\n  }\n  .header .main-header .header-left .header-logo a img {\n    max-width: 110px;\n}\n  .gset{\n    width: max-content;\n   }\n  .gt_white_content .gt_languages{\n    flex-flow: column;\n  }\n  .gt_white_content{\n    margin: unset !important;\n    transform: translate(-50%,-50%) !important;\n    width: 320px !important;\n  }\n  .box-newsletter .image-1 img {\n    width: 75px;\n  }\n  .gt_container-unisv1 a.glink span {\n    font-size: 17px;\n}\na.glink img{\n  width: 28px;\n  height: 28px;\n}\n.gtranslate_wrapper {\n  left: 3%;\n  top: 15px;\n}\n.header-right .get_start_button .btn.btn-brand-1{\n  display: none;\n}\n}\n\n@media (max-width: 499.98px) {\n\n  .footer .width-16,\n  .footer .width-20,\n  .footer .width-23 {\n    width: 100%;\n  }\n\n  .box-newsletter .image-1 img {\n    width: 55px;\n  }\n\n  h2 {\n    font-size: 25px;\n    line-height: 35px;\n  }\n  /* .gtranslate_wrapper {\n    right: 20%;\n  } */\n  .burger-icon {\n    top: 16px;\n  }\n\n  .box-newsletter {\n    padding: 25px;\n  }\n}\n\n/* 13-05-24 sakthi changes start */\n\n.custom_uploadBtn input[type=\"file\"] {\n  max-width: 100%;\n  padding: 5px;\n  background: #fff;\n  font-size: 14px;\n  border: 1px solid #cde2e7 !important;\n  border-radius: 8px !important;\n  color: #3d565f !important;\n}\n\n.custom_uploadBtn input[type=\"file\"]::file-selector-button {\n  margin-right: 20px;\n  border: none;\n  background: #2d699b;\n  padding: 7px 20px;\n  border-radius: 8px;\n  color: #ffe7bb;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.uploadLabel {\n  color: #3d565f;\n}\n\n.upload_PreviewImg,\n.custom_uploadBtn video {\n  width: 180px;\n  height: 180px;\n}\n\n.upload_PreviewImg img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n@media (max-width:575px) {\n  .upload_PreviewImg {\n    width: 130px;\n    height: 130px;\n  }\n}\n\n\n/* start of hariharan css */\n\n.custom_section {\n  /* padding-top: 54px; */\n  padding-top: 90px;\n}\n\n.profile_card {\n  /* border: 1px solid var(--light_blue) !important; */\n  /* border-radius: 10px; */\n  /* padding: 30px; */\n}\n\n.profile_wrapper {\n  min-width: 100px;\n  width: 100px;\n  max-width: 100px;\n  min-height: 100px;\n  height: 100px;\n  max-height: 100px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: none;\n  outline: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.profile_wrapper img {\n  min-width: 100%;\n  width: 100%;\n  max-width: 100%;\n  min-height: 100%;\n  height: 100%;\n  max-height: 100%;\n  object-fit: cover;\n}\n\n/* start of toggle - 1 */\n\n.custom_toggle .switch {\n  position: relative;\n  display: inline-block;\n  width: 42px;\n  height: 22px;\n}\n\n.custom_toggle .switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.custom_toggle .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: transparent;\n  border: 1px solid var(--h_themeBlue);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.custom_toggle .slider:before {\n  position: absolute;\n  content: \"\";\n  top: 2px;\n  height: 16px;\n  width: 16px;\n  left: 3px;\n  bottom: 3px;\n  background: var(--h_themeBlue);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.custom_toggle input:checked+.slider {\n  background: var(--h_themeBlue);\n  /* border: 1px solid var(--primary-color); */\n}\n\n.custom_toggle input:focus+.slider {\n  box-shadow: 0 0 1px var(--h_themeBlue);\n}\n\n.custom_toggle input:checked+.slider:before {\n  -webkit-transform: translateX(18px);\n  -ms-transform: translateX(18px);\n  transform: translateX(18px);\n  background: var(--h_white);\n\n}\n\n/* Rounded sliders */\n.custom_toggle .slider.round {\n  border-radius: 34px;\n}\n\n.custom_toggle .slider.round:before {\n  border-radius: 50%;\n}\n\n/* end of toggle -1 */\n\n.profile_qr_wrapper {\n  min-width: 200px;\n  width: 200px;\n  max-width: 200px;\n  min-height: 200px;\n  height: 200px;\n  max-height: 200px;\n  overflow: hidden;\n}\n\n.profile_qr_wrapper img {\n  min-width: 100%;\n  width: 100%;\n  max-width: 100%;\n  min-height: 100%;\n  height: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.profile_label {\n  font-size: 15px;\n}\n\n.proile_label_span {\n  font-size: 13px;\n  font-weight: 450;\n  color: var(--h_darkGray);\n}\n\n.profile_desc {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.support_search_wrapper {\n  padding: 8px;\n  background: var(--h_lightGray);\n  border-radius: 5px;\n  max-width: 500px;\n  height: 50px;\n}\n\n.support_search_wrapper input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-weight: 500;\n  font-size: 15px;\n}\n\n.support_search_wrapper input::placeholder {\n  opacity: 0.7;\n}\n\n.support_search_button {\n  color: var(--h_white);\n  background: var(--h_themeBlue);\n  border: none;\n  outline: none;\n  padding: 5px 20px;\n  border-radius: 5px;\n  font-weight: 500;\n}\n\n.support_title {\n  font-size: 17px;\n}\n\n.self_service_card_wrapper {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n}\n\n.self_service_card {\n  min-height: 150px;\n  height: 150px;\n  max-height: 150px;\n  border-radius: 5px;\n  padding: 20px;\n  cursor: pointer;\n  border: 1px solid var(--h_lightGray2);\n}\n\n.self_service_card img {\n  width: 45px;\n}\n\n.container {\n  /* max-width: 90%; */\n}\n\n.self_service_card p {\n  font-weight: 450;\n  color: var(--h_darkGray);\n}\n\n.self_service_card:hover {\n  background: var(--h_lightGray2);\n}\n\n.faq_cms_section h5 {\n  font-size: 18px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n.faq_cms_section p {\n  font-size: 15px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  font-weight: 450;\n  line-height: 2;\n  color: var(--h_darkGray);\n}\n\n\n/* start of table - 1 */\n\n/* start of table -3 */\n\n.w_200 {\n  min-width: 200px;\n}\n\n.w_150 {\n  min-width: 150px;\n}\n\n.w_250 {\n  min-width: 250px;\n}\n\n.w_150 {\n  min-width: 150px;\n}\n\n.card_table {\n  background: var(--grayClr1);\n  padding: 15px;\n  overflow: hidden;\n}\n\n.card_table .card_table_body {\n  overflow: hidden;\n}\n\n.card_table .table-body.asrt-table-body {\n  overflow: scroll;\n  margin-top: 0px !important;\n}\n\n.card_table .table {\n  background: transparent !important;\n}\n\n.card_table .table tr th {\n  background: transparent !important;\n  color: var(--blackWhite);\n  border: none;\n}\n\n.card_table .table tr {\n  border: none;\n}\n\n.card_table .table tr th {\n  background: transparent !important;\n  color: var(--h_themeBlue);\n  border: none;\n  border-bottom: 2px solid var(--h_themeBlue);\n  padding-bottom: 20px !important;\n  font-size: 15px;\n}\n\n.card_table .table.table-bordered tbody tr td {\n  background: transparent;\n  border: none;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: var(--h_black);\n  font-size: 14px;\n}\n\n.card_table .row.table-foot.asrt-table-foot {\n  margin: 30px 10px;\n  /* border: 1px solid var(--green2); */\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-radius: 5px;\n  background: transparent;\n}\n\n.card_table .row.table-foot.asrt-table-foot .col-md-6:first-child {\n  align-items: center;\n  display: flex;\n  color: var(--h_black);\n}\n\n.card_table .row.table-foot.asrt-table-foot .pagination {\n  border: none !important;\n  /* background: var(--themeLinear); */\n  width: fit-content;\n  margin-left: auto;\n  border-radius: 0.375rem;\n}\n\n.card_table .row.table-foot.asrt-table-foot .pagination .page-link {\n  background: transparent;\n  color: var(--h_black);\n}\n\n.card_table .row.table-foot.asrt-table-foot .pagination .page-link:hover {\n  color: var(--h_themeBlue);\n}\n\n.card_table .row.table-foot.asrt-table-foot .pagination .page-link input {\n  background: transparent;\n  color: var(--h_black);\n  box-shadow: none;\n  outline: none;\n}\n\n.card_table .row.table-foot.asrt-table-foot .pagination .disabled.page-item .page-link {\n  opacity: 0.7;\n}\n\n.card_table .table-striped>tbody>tr:nth-of-type(odd)>* {\n  background: transparent !important;\n}\n\n.card_table .table-striped>tbody>tr:nth-of-type(odd)>* {\n  --bs-table-bg-type: none !important;\n}\n\n.card_table .table.table-bordered.table-striped {\n  margin-top: 30px;\n}\n\n.card_table .table_filter .form-control {\n  padding: 5px 10px !important;\n  height: 40px !important;\n\n}\n\n.card_table .input-group.asrt-page-length .form-control {\n  padding: 5px 10px !important;\n  height: 40px !important;\n}\n\n.card_table .col-md-6.float-right.text-right {\n\n  margin-top: 0px;\n}\n\n/* .card_table .row.table-head.asrt-table-head {\n  gap: 15px;\n} */\n\n/* end of table - 2 */\n\n.file_name_wrapper {\n  border: 1px solid #cde2e7 !important;\n  border-radius: 8px !important;\n  color: #3d565f !important;\n  height: 54px !important;\n  padding: 18px 20px !important;\n  display: flex;\n  align-items: center;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n/* new css */\n\n.profileicon {\n  color: #2d699b;\n}\n\n.profileicon svg, .profileicon img {\n  width: 36px;\n  height: 36px;\n  object-fit: cover;\n  border-radius: 50px;\n}\n\n.header .main-header .header-left .header-right {\n  padding: 15px 0 15px 0px;\n}\n\ndiv.ruby-wrapper {\n  /* width: 780px; */\n  /* width: 800px; */\n}\n\n.formbtn:focus {\n  box-shadow: none;\n}\n\n.btn.MuiButton-text {\n  min-width: auto;\n  font-size: 22px;\n  padding-left: 12px;\n  padding-right: 10px;\n}\n\n.btn.MuiButton-text:hover {\n  background-color: transparent;\n}\n\n.alllogin .form-control {\n  padding-left: 7px !important;\n  padding-right: 7px !important;\n  width: 100% !important;\n  max-width: 60px;\n}\n\n.form-control__control {\n  padding: 0 !important;\n}\n\n.form-control__control--menu-is-open,\n.form-control__control--is-focused {\n  box-shadow: 0 0 0 1px #06d6a0 !important;\n}\n\n.form-control__input-container {\n  border: 0 !important;\n  margin: 0 !important;\n  padding: 14px 20px !important;\n}\n\n.form-control__value-container {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.form-control__single-value {\n  padding: 0px 20px;\n}\n\n.custom_uploadBtn video {\n  display: block;\n  margin-bottom: 15px;\n}\n\n.PhoneInputInput {\n  border: 0;\n  outline: 0;\n  padding: 12px 0px;\n}\n\n.customer-reset-password {\n  padding-top: 130px;\n  padding-bottom: 60px;\n}\n\n.boxbg {\n  background-color: #e9ecef;\n  border: 1px solid #cde2e7;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 24px;\n}\n\n\n\n\n\n/* new css */\n\n\n\n\n\n.head_profile_wrapper {\n  transition: all 0.3s ease;\n}\n\n.profile_dropdown_menus {\n  content: '';\n  /* position: absolute;\n  width: 200px;\n  height: 30px;\n  background: red;\n  top: 50px;\n  transition: transform 0.3s ease; */\n}\n\n.profileicon:hover .profile_dropdown_menus {\n\n  content: '';\n  width: 200px;\n  height: 30px;\n  background: red;\n  top: 50px;\n  /* transition: transform 0.3s ease; */\n}\n\n.header_profile_wrapper ul,\n.header_profile_wrapper li {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.header_profile_wrapper ul.ruby-menu .profile_dropdowns li button {\n  background: #fff;\n  color: #666;\n  font-weight: 600;\n  line-height: 40px;\n  padding: 0 35px 0 25px;\n  font-size: 14px;\n}\n\n.header_profile_wrapper ul.ruby-menu .profile_dropdowns li button {\n  background: #fff;\n  color: #666;\n  font-weight: 600;\n  line-height: 40px;\n  padding: 0 35px 0 25px;\n  font-size: 14px;\n}\n\n.header_profile_wrapper ul.ruby-menu .profile_dropdowns li:hover {\n  background: #efefef;\n\n}\n\n.btn_max_width{\n  max-width: 200px;\n}\n\n/* media */\n\n@media (min-width:450px) {\n  .custom_section {\n    padding-top: 90px;\n  }\n}\n\n@media (min-width:576px) {\n  .custom_section {\n    padding-top: 105px;\n  }\n\n  .support_search_wrapper input {\n\n    font-size: 16px;\n  }\n}\n\n@media screen and (min-width:768px) {\n  .support_title {\n    font-size: 20px;\n  }\n\n  .faq_cms_section h5 {\n    font-size: 20px;\n  }\n\n  .card_table .col-md-6.float-right.text-right {\n    display: flex;\n    justify-content: end;\n  }\n\n  /* ul.ruby-menu>li>ul {\n    transform: translateY(45px);\n    transition: all 0.3s ease;\n  }\n   \n   .header_profile_wrapper ul.ruby-menu>li:hover>ul {\n    transform: translateY(10px);\n  } */\n}\n\n\n\n@media (min-width:1200px) {\n  .custom_section {\n    padding-top: 97px;\n  }\n\n  .header_profile_wrapper {\n    display: block !important;\n  }\n\n  .get_start_button {\n    display: block !important;\n  }\n}\n\n@media (max-width: 768px) {\n\n  .card_table .row.table-foot.asrt-table-foot .col-md-6:first-child {\n    margin-bottom: 10px;\n    display: flex;\n    justify-content: center;\n  }\n\n  .card_table .row.table-foot.asrt-table-foot .col-md-6:nth-child(2) {\n    display: flex;\n    justify-content: center;\n  }\n\n  .card_table .col-md-6.float-right.text-right {\n    margin-top: 10px;\n  }\n\n}\n\n@media (max-width:400px) {\n\n  .card_table .row.table-foot.asrt-table-foot .col-md-6:first-child {\n    font-size: 13px;\n    display: flex;\n    justify-content: center;\n  }\n\n  .card_table .row.table-foot.asrt-table-foot .col-md-6:nth-child(2) {\n    font-size: 13px;\n    display: flex;\n    justify-content: center;\n  }\n\n  .card_table .row.table-foot.asrt-table-foot .pagination .page-link {\n    font-size: 13px;\n    padding-left: 6px;\n    padding-right: 6px;\n  }\n\n  .card_table .row.table-foot.asrt-table-foot .pagination .page-link input {\n    font-size: 13px;\n  }\n}\n\n@media screen and (min-width:360px) and (max-width: 575px) {\n  .chatlist {\n    width: 350px;\n    right: 10px;\n  }\n\n  .chatbox {\n    bottom: 5%;\n  }\n}\n\n@media screen and (min-width:320px) and (max-width: 359px) {\n  .chatlist {\n    width: 310px;\n    right: 6px;\n  }\n\n  .box_left,\n  .box_right {\n    width: 260px;\n    min-width: 260px;\n  }\n\n  .chatbox {\n    bottom: 5%;\n  }\n}\n\n\n\n/* end of hariharan css */\n\n\n\n\n.mob-accordion .accordion-button{\n  padding: 0.5rem 0.6rem;\n}\n.mob-accordion .accordion-item{\n  background-color: transparent;\n  border: 1px solid transparent;\n}\n.mob-accordion a{\n  text-decoration: none;\n  cursor: pointer;\n  color: #2d699b;\n  font-weight: 600;\n}\n.mob-accordion a:hover{\n  color: #06D6A0;\n}\n.mob-accordion .accordion-button:focus, .mob-accordion .accordion-button:not(.collapsed){\n  border-color: transparent;\n  background-color: transparent;\n  box-shadow: unset;\n}\n.mob-accordion .subaccitem{\n  margin-bottom: 10px;\n}\n\n\n.first_head{\n  background-color: #2d699b;\n  height: 50px;\n}\n.first_head a{\n  color: #fff;\n  text-decoration: none;\n}\n.first_head a:hover{\n  color: #fff;\n}\n\n/* phoneInputCom */\n.phoneInputCom *{\n  /* border: 1px solid #ff0000 !important; */\n}\noption{\n  border: 40px solid red !important;\n}\nspan.tft:hover {\n  color: #d83d10;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
